import { takeEvery, call, put } from "redux-saga/effects";
import { GET_STATICBLOCK_LIST, SET_STATICBLOCK_LIST } from "../actions";
import { apiUrl, uniqueID } from "../components/Settings/Config";
import Axios from "axios";

export const watchGetStaticBlockList = function* () {
  yield takeEvery(GET_STATICBLOCK_LIST, workerGetStaticBlockList);
};

function* workerGetStaticBlockList() {
  try {
    const uri = apiUrl + "staticblock/getlist?uniqueID=" + uniqueID;
    const result = yield call(Axios.get, uri);
    var resultArr = [];
    resultArr.push(result.data);
    yield put({ type: SET_STATICBLOCK_LIST, value: resultArr });
  } catch {
    console.log("Get Static Block failed");
  }
}
